<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 contractEquipmentTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="equipment"
                        arrows >
                    <template slot="gofixTab:equipment">
                        <b-row class="heig-frame-child">
                            <b-col md="3">
                                <split-pane :min-percent="25" :default-percent="100" split="horizontal" >
                                    <template slot="paneL">
                                        <gofix-card title="property" class="contractTree h-100 contractEquimentTree" v-bind:class="{'run-loading':loadingProperty}" >
                                            <div class="contenAbsolute">
                                                <div class="tree-view-properties">
                                                    <tree :data="treeData" :options="opts" @node:clicked="selectProperty" ref="treeViewProperties">
                                                        <div slot-scope="{ node }" class="node-container">{{ node.text }}</div>
                                                    </tree>
                                                </div>
                                            </div>
                                        </gofix-card>
                                    </template>
                                    <template slot="paneR">

                                    </template>
                                </split-pane>
                            </b-col>
                            <b-col md="9" class="pl-0">
                                <gofix-card title="Property Detail">
                                    <b-row>
                                        <b-col md="3">
                                            <gofix-text-field label="property name" oneline>{{propertySelected && propertySelected.name ? propertySelected.name : "-"}}</gofix-text-field>
                                        </b-col>
                                        <b-col md="3">
                                            <gofix-text-field label="owner" oneline>{{propertySelected && propertySelected.owner ? propertySelected.owner : "-"}}</gofix-text-field>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-text-field label="address" oneline>{{propertySelected && propertySelected.addessText ? propertySelected.addessText : "-"}}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </gofix-card>
                                <gofix-card fullContent class="equipmentCardTable scontract-equipment-scroll">
                                    <gofix-default-table
                                            class="noFullHeight scrollAbsolute"
                                            :settings="tableConfig"
                                            :table-items="tableItems"
                                            @load-items="getTableData"
                                            @row-click="detailItem"
                                            ref="gofixTable">
                                        <template slot="gofix_table:root_path" slot-scope="row">
                                            {{ row.item.location_info ? row.item.location_info.root_path : '--' }}
                                        </template>
                                        <template v-if="routeLink" slot="gofix_table:view" slot-scope="row">
                                            <router-link
                                                    :to="`${routeLink.link}/${row.item.id}`"
                                            >{{ routeLink.label }}</router-link>
                                        </template>
                                    </gofix-default-table>
                                </gofix-card>
                            </b-col>
                        </b-row>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import LiquorTree from "liquor-tree";
    import splitPane from "vue-splitpane";
    import { mapGetters } from "vuex";
    import { filters } from '@/_filterVar.js'

    export default {
        name: "supplier-equipment",
        components: {
            [LiquorTree.name]: LiquorTree,
            splitPane
        },
        data() {
            return {
                contract_tab:tabData.supplier_contract,
                tableConfig:{
                    controls:{
                        create: null,
                        delete: null,
                        tableExport: false
                    },
                    name: 'supplier-contract-equipment',
                    filter: JSON.parse(JSON.stringify(filters['s_equipment'])),
                    page: 1,
                    limit: 100,
                    totalPage: 0,
                    total: 0,
                    isCMS: 1
                },
                pages: {
                    isCMS: '1',
                    limit: 100,
                    page: 1,
                    totalPage: 0,
                    filter: JSON.parse(JSON.stringify(filters['s_equipment']))
                },
                tableItems: [],
                items: [],
                treeData: this.getData(),
                opts: {
                    minFetchDelay: 500,
                    fetchData: node => {
                        node.isBatch = false;
                        if(node.data.id == this.rootId) {
                            return new Promise((resolve, reject) => {
                                resolve([]);
                            });
                        }
                        return new Promise((resolve, reject) => {
                            global
                                .axios(
                                    `api/s-contracts/${this.$route.params.id}/tree-properties/${node.data.id}`, {
                                        method: "GET",
                                        params: {
                                            is_property: false,
                                            is_active: true
                                        },
                                        headers: {
                                            Accept: "application/json"
                                        }
                                    }
                                )
                                .then(response => {
                                    if (this.nodeModel) {
                                        if (this.nodeModel.data.id != this.nodeSelected.data.id) {
                                            resolve(response.data.data);
                                        } else resolve([]);
                                    } else resolve(response.data.data);
                                })
                                .catch(error => reject(error));
                        });
                    }
                },
                rootId: null,
                loadingProperty: true,
                propertySelected: null,
                locationIdModal: null,
                replace: function(key, value) {
                    switch (key) {
                        case "children":
                            if (value.length > 0) {
                                return value;
                            } else {
                                return null;
                            }
                            break;
                        default:
                            return value;
                    }
                },
                pagesEquipmentType: {
                    page: 1,
                    limit: 100,
                    filter: {
                        node_type: "equipment_type",
                        search: ""
                    }
                },
                equipmentType: null,
                equipment: {
                    location: "",
                    location_id: "",
                    equipment_category: "",
                    equipment_category_id: "",
                    equipment_type: "",
                    equipment_group_id: "",
                    serial_number: "",
                    brand: "",
                    brand_id: "",
                    model: "",
                    model_id: "",
                    tag_name: "",
                    purchase_date: null,
                    installation_date: null,
                    warranty_expiry: null,
                    purchase_price: "",
                    installation_price: "",
                    previous_equipment: "",
                    contract_id: this.$route.params.id
                },
                equipmentBrand: [],
                equipmentBrandSelected: null,
                equipmentModel: [],
                equipmentModelSelected: null,
                isEdit: {
                    Brand: true,
                    Model: true
                },
                isAction: false,
                titleModel: 'Create New Equipment'
            };
        },
        watch: {
            ClientContractID: function(val, old) {
                if(val && val.client_id !== old.client_id) {
                    return this.$router.push(`/v2/contract-supplier`)
                }
            },
            equipmentType: function(val, old) {
                if (val) {
                    global
                        .axios(`api/equipment/brands?equipment_group_id=${val.id}`, {
                            method: "GET",
                            headers: {
                                Accept: "application/json"
                            }
                        })
                        .then(response => {
                            if (!this.isEdit.Brand) {
                                this.equipmentBrandSelected = null;
                                this.equipmentModel = [];
                                this.equipmentModelSelected = null;
                            }
                            this.equipmentBrand = response.data.data;
                            this.isEdit.Brand = false;
                        })
                        .catch(error => {});
                } else {
                    this.equipmentBrandSelected = null;
                    this.equipmentBrand = [];
                    this.equipmentModel = [];
                    this.equipmentModelSelected = null;
                }
            },
            equipmentBrandSelected: function(val, old) {
                if (val) {
                    global
                        .axios(`api/equipment/models?type_brand_id=${val.pivot.id}`, {
                            method: "GET",
                            data: {},
                            headers: {
                                Accept: "application/json"
                            }
                        })
                        .then(response => {
                            if (!this.isEdit.Model)
                                this.equipmentModelSelected = null;
                            this.isEdit.Model = false;
                            this.equipmentModel = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        });
                } else {
                    this.equipmentModelSelected = null;
                    this.equipmentModel = [];
                }
            },
            SContract: function(val, old) {
                if(old && val && old.id != val.id) {
                    this.tableConfig.filter.contract_id.value = val.id;
                    this.$refs.gofixTable.reloadTableItems();
                }
            }
        },
        computed: {
            ...mapGetters({
                equipments: "SupplierEquipmentController/equipments",
                EquipmentStructure: "EquipmentStructureController/EquipmentStructure",
                SContract: "ContractController/SContract",
                ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        async created() {
            //Set contract id on path
            if (!this.$route.params.hasOwnProperty("id") || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/contract-supplier`)
            }
            if(!this.SContract || !this.SContract.hasOwnProperty('id')) {
                this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id)
                    .catch(error => {
                        return this.$router.push(`/v2/contract-supplier`)
                    })
            }

            this.pages.filter.contract_id.value = this.$route.params.id;
            if(this.equipments.items.length == 0 || this.equipments.pages.filter.contract_id.value != this.$route.params.id) {
                if(this.SContract && this.$refs.gofixTable) {
                    this.$refs.gofixTable.reloadTableItems();
                }
            }
            else {
                this.pages = JSON.parse(JSON.stringify(this.equipments.pages))
            }

            if (this.EquipmentStructure.items.length == 0) {
                this.$store.dispatch(
                    "EquipmentStructureController/getItems",
                    this.pagesEquipmentType
                );
            }
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contract_id.value = this.pages.filter.contract_id.value;
                tableRequest.filter.location_id.value = this.pages.filter.location_id.value;
                tableRequest.filter['equipment.is_active'] = {  type: 'boolean', value: true }
                await this.$store.dispatch("SupplierEquipmentController/getEquipments", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the supplier contract equipment", "danger");
                        reject();
                    })
            },
            getData() {
                return new Promise((resolve, reject) => {
                    this.loadingProperty = true;
                    global
                        .axios(`api/s-contracts/${this.$route.params.id}/tree-properties/0`, {
                            method: "GET",
                            params: {
                                is_property: false,
                                is_active: true
                            },
                            headers: {
                                Accept: "application/json"
                            }
                        })
                        .then(response => {
                            this.rootId = response.data.data[0].data.id;
                            if(response.data.data[0].children.length == 0) {
                                response.data.data[0].isBatch = false;
                            }
                            this.loadingProperty = false;
                            resolve(response.data.data);
                        })
                        .catch(error => {
                            this.loadingProperty = false;
                            reject(error);
                        });
                });
            },
            selectProperty(node, status) {
                this.locationSelected = node;
                this.propertySelected = node.data;
                this.pages.filter.location_id.value = node.data.id;
                if (!status) this.$refs.gofixTable.reloadTableItems();
            },
            async detailItem(item) {
                this.titleModel = 'Equipment'
                this.equipment.id = item.id;
                this.isEdit = {
                    Brand: true,
                    Model: true
                };
                let detail = Object.assign({}, item);
                this.locationIdModal = {
                    children: null,
                    data: {
                        id: detail.location_id,
                        name: detail.location_info.name,
                        text: detail.location_info.name,
                    },
                    text: detail.location_info.name,
                };

                this.equipmentType = {
                    id: detail.equipment_group_id,
                    name: detail.equipment_type,
                    node_type: "equipment_type",
                    text: detail.equipment_type,
                };
                this.equipment = detail;
                this.equipmentBrandSelected = null;
                this.equipmentModelSelected = null;
                this.equipmentBrand = [];
                this.equipmentModel = [];

                if (detail.brand_id) {
                    let type_brand_link = await global.axios(`api/equipment/type-brand-link`, {
                        method: "POST",
                        params: {
                            equipment_group_id: detail.equipment_group_id,
                            brand_id: detail.brand_id
                        },
                        headers: {
                            Accept: "application/json"
                        }
                    });
                    this.equipmentBrandSelected = {
                        created_at: null,
                        deleted_at: null,
                        id: detail.brand_id,
                        name: detail.brand,
                        pivot: {
                            brand_Id: detail.brand_id,
                            equipment_group_id: detail.equipment_group_id,
                            id: type_brand_link.data.data.id
                        }
                    };
                    if (detail.model_id) {
                        this.equipmentModelSelected = {
                            id: detail.model_id,
                            name: detail.model,
                            type_brand_id: type_brand_link.data.data,
                        }
                    }
                }

                //this.$refs["add-modal-Equipment"].show();
            },
            refreshProperty() {
                this.loadingProperty = true;
                global
                    .axios(`api/s-contracts/${this.$route.params.id}/tree-properties/0`, {
                        method: "GET",
                        params: {
                            is_property: false
                        },
                        headers: {
                            Accept: "application/json"
                        }
                    })
                    .then(response => {
                        this.loadingProperty = false;
                        this.$refs.treeViewProperties.setModel(response.data.data);
                    })
                    .catch(error => {
                        this.loadingProperty = false;
                    });
            },
        }
    }
</script>
